/**
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */

import { Logger } from '@nestjs/common';
import { NestFactory } from '@nestjs/core';
import { appSettings } from '../../config';
import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';

import { AppModule } from './app/app.module';

async function bootstrap() {
  const app = await NestFactory.create(AppModule);
  app.enableCors();
   
   const globalPrefix = 'erpx';
   app.setGlobalPrefix(globalPrefix);
   const port =  appSettings.hrms_port;
   const options = new DocumentBuilder()
     .setTitle('ERPX')
     .setDescription('ERP X')
     .setVersion('1.0')
     .addTag('')
     .build();
   const document = SwaggerModule.createDocument(app, options);
   SwaggerModule.setup('erpx', app, document);
   // await app.listen(3000);
   await app.listen(port, () => {
     Logger.log('Listening at http://localhost:' + port + '/' + globalPrefix);
   });
}

bootstrap();
